// import moment from 'moment';

function checkTime(i) {
    if (i < 10) {
        i = "0" + i;
    }
    return i;
}

export const Trace = (name, isShow = false) => {
    // eslint-disable-next-line func-names
    return function(...messages) {
        //! 各个模块的开关
        if (!isShow) {
            return;
        }

        //!正式环境不打印log
        if (process.env.NODE_ENV === "production") {
            return;
        }

        // eslint-disable-next-line no-console

        let date = new Date();
        let time;

        time = `${checkTime(date.getHours())}:${checkTime(
            date.getMinutes()
        )}:${checkTime(date.getSeconds())}.${date.getMilliseconds()}`;

        console.log(`${time} ${name}:`, ...messages);
    };
};



// WEBPACK FOOTER //
// ./src/utils/trace2.js